module.exports = __webpack_public_path__ + "images/img_hexagon-00fe2aa94c.png";